import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";

const CommunityTeaser = () => (
  <section
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="community-teaser-section"
  >
    <div className="max-w-4xl mx-auto px-6 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-4">
          <div className="w-16 h-16 rounded-full bg-[#D7B2A3]/40 flex items-center justify-center mb-6">
            <Users className="text-[#B89B63]" size={26} />
          </div>
          <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-3">Community</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-[#4F5D4F] leading-tight tracking-tight" data-testid="community-headline">
            You weren't meant to do this alone.
          </h2>
        </div>

        <div className="md:col-span-8">
          <div className="bg-white border border-[#D7B2A3]/60 p-8 sm:p-10">
            <h3 className="font-serif text-2xl text-[#4F5D4F] mb-3">Connecting Grounds</h3>
            <p className="text-[#4F5D4F]/85 font-light leading-relaxed mb-6">
              A free monthly virtual gathering for women questioning and rebuilding after
              high-control Christianity.
            </p>
            <ul className="space-y-2 text-[#4F5D4F]/80 font-light mb-6">
              <li className="flex items-baseline gap-3">
                <span className="text-[#B89B63]">·</span> No theological debates.
              </li>
              <li className="flex items-baseline gap-3">
                <span className="text-[#B89B63]">·</span> No pressure to have the right answer.
              </li>
              <li className="flex items-baseline gap-3">
                <span className="text-[#B89B63]">·</span> No requirement to know where you'll land.
              </li>
              <li className="flex items-baseline gap-3">
                <span className="text-[#B89B63]">·</span> Just a place to be around women who understand.
              </li>
            </ul>
            <p className="text-sm text-[#8C9A88] italic mb-8">
              The 2nd Friday of every month · on Google Meet
            </p>
            <Link
              to="/community"
              className="group inline-flex items-center gap-3 bg-[#4F5D4F] text-[#F6F1EA] hover:bg-[#3a453a] px-7 py-4 text-xs tracking-eyebrow uppercase transition-colors"
              data-testid="community-teaser-cta"
            >
              Join Connecting Grounds
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CommunityTeaser;
